import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <motion.div 
            className="footer-message"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="footer-title">The future of delivery is here. Right on time.</h2>
            <p className="footer-description">
              With Wing, delivery's easy, fast, and fun. Learn more and find out if Wing delivers in your area.
            </p>
            <motion.a 
              href="#get-delivery" 
              className="btn footer-cta"
              whileHover={{ scale: 1.05, backgroundColor: "#e6b800" }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="dot">•</span> Get delivery
            </motion.a>
          </motion.div>
        </div>
        
       
        
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Wing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
